var _excluded = ["autoFocus", "autoComplete", "disabled", "component", "error", "helperText", "success", "label", "name", "id", "value", "placeholder", "className", "counter", "onChange", "onFocus", "onBlur", "height"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Box, Flex } from '@creditas-ui/layout';
import { useForkRef } from '@creditas-ui/utilities';
import React, { useState } from 'react';
import { InputHelperText } from '../InputHelperText';
import { useInputBoxed } from '../InputBoxed/useInputBoxed';
import { TextAreaBoxedElement, TextAreaCounterText, TextAreaInput, TextAreaLabel } from './TextArea.style';
export var TextArea = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    autoFocus = false,
    autoComplete = 'off',
    disabled = false,
    component = 'textarea',
    error,
    helperText,
    success,
    label,
    name,
    id,
    value,
    placeholder,
    className,
    counter,
    onChange = () => {
      /* noop */
    },
    onFocus,
    onBlur,
    height
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var [charsCounter, setCharsCounter] = useState((value === null || value === void 0 ? void 0 : value.length) || 0);
  var {
    active,
    focused,
    inputRef,
    handleOnBlur,
    handleOnFocus,
    handleOnClick
  } = useInputBoxed({
    value,
    disabled,
    placeholder,
    onBlur,
    onFocus,
    autoFocus
  });
  var handleRefs = useForkRef(ref, inputRef);

  var handleChange = event => {
    var {
      value
    } = event.currentTarget;
    setCharsCounter(value === null || value === void 0 ? void 0 : value.length);
    onChange(event);
  };

  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(TextAreaBoxedElement, {
    onClick: handleOnClick,
    focused: focused,
    height: height
  }, /*#__PURE__*/React.createElement(TextAreaLabel, {
    htmlFor: id,
    active: active,
    disabled: disabled,
    error: Boolean(error)
  }, label), /*#__PURE__*/React.createElement(TextAreaInput, _extends({
    component: component,
    ref: handleRefs,
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    disabled: disabled,
    name: name,
    id: id,
    value: value,
    placeholder: placeholder,
    className: className,
    onChange: handleChange,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur
  }, props))), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between"
  }, helperText && !success && !error && /*#__PURE__*/React.createElement(InputHelperText, null, helperText), success && !error && /*#__PURE__*/React.createElement(InputHelperText, {
    success: true
  }, success), error && !disabled && /*#__PURE__*/React.createElement(InputHelperText, {
    error: true
  }, error), counter !== undefined && /*#__PURE__*/React.createElement(TextAreaCounterText, null, charsCounter, "/", counter)));
});
//# sourceMappingURL=TextArea.js.map